import { Button, IconButton, Text } from '@components'
import { Expand, Mic, SendIcon } from 'lucide-solid'
import { useService } from 'solid-services'
import { Flex } from 'styled-system/jsx'
import { useUi, useUpsert } from '../state'
import './input.css'

const Toolbar = (props: { onSend: () => void }) => {
	const { sendIsLoading } = useService(useUpsert)()
	const { toggleIsExpanded } = useService(useUi)()

	return (
		<Flex
			w="100%"
			justifyContent="space-between"
		>
			<div id="custom-toolbar">
				<select class="ql-header">
					<option selected />
					<option value="1">Heading 1</option>
					<option value="2">Heading 2</option>
				</select>
				<button
					type="button"
					class="ql-bold"
				/>
				<button
					type="button"
					class="ql-italic"
				/>
				<button
					type="button"
					class="ql-underline"
				/>
				<button
					type="button"
					class="ql-list"
					value="ordered"
				/>
				<button
					type="button"
					class="ql-list"
					value="bullet"
				/>
				<button
					type="button"
					class="ql-link"
				/>
				<button
					type="button"
					class="ql-image"
				/>
				<button
					type="button"
					class="ql-video"
				/>
				<button
					type="button"
					class="ql-undo"
				>
					<Mic />
				</button>
			</div>

			<Flex gap={2}>
				<IconButton
					onClick={toggleIsExpanded}
					variant="ghost"
					colorPalette="gray"
					size="xs"
				>
					<Expand />
				</IconButton>
				<Button
					onClick={props.onSend}
					loading={sendIsLoading()}
					size="xs"
					type="submit"
					variant="solid"
					height="auto"
					colorPalette="tscGreen"
				>
					<SendIcon />
					<Text>Send</Text>
				</Button>
			</Flex>
		</Flex>
	)
}

export default Toolbar
